import { z } from "zod"
import { ServiceRateTypeEnumSchema } from "../../services/models/ServiceRateTypesDto"
import errorMap from "@gap/backend/util/validations/validation-error-map"

export const proposalStep3ServiceAgreementTypeEnum = ['agreed', 'estimate'] as const
export const proposalStep3ServiceAgreementTypeEnumSchema = z.enum(proposalStep3ServiceAgreementTypeEnum, { errorMap })
export type ProposalStep3ServiceAgreementTypeEnum = z.output<typeof proposalStep3ServiceAgreementTypeEnumSchema>

export const step3Service = z.object({
   serviceId: z.string(),
   servicePrice: z.number(),
   serviceUnits: z.number().optional(),
   serviceAgreementType: proposalStep3ServiceAgreementTypeEnumSchema
})
export type step3ServiceDto = z.output<typeof step3Service>

export const ProposalStep3BaseStep3 = z.object({
   services: z.array(step3Service),
   serviceRateType: ServiceRateTypeEnumSchema,
   monthlyInstallmentsOver12Months: z.boolean()
})
export type ProposalStep3BaseStep3Dto = z.output<typeof ProposalStep3BaseStep3>

export const ProposalStep3AnnualPayment = z.object({
   annualPayment: z.boolean(),
   annualPaymentDiscount: z.number()
})

export const ProposalStep3PaymentOnCompletion = z.object({
   paymentOnCompletion: z.boolean()
})

export const ProposalStep3StagedPayments = z.object({
   stagedPayments: z.boolean(),
   stagedPaymentUpfront: z.number(),
   stagedPaymentMilestone: z.number()
})

export const ProposalStep3UpfrontPayment = z.object({
   upfrontPaymentInFull: z.boolean(),
   upfrontPaymentInFullDiscount: z.number()
})

export const MonthlyInstallmentsOver12Months = z.object({
   monthlyInstallmentsOver12Months: z.boolean()
})

export const ProposalStep3ServiceMonthly = ProposalStep3BaseStep3.merge(ProposalStep3AnnualPayment).merge(z.object({ serviceRateType: z.literal('Per month') }))
export type ProposalStep3ServiceMonthlyDto = z.output<typeof ProposalStep3ServiceMonthly>

export const ProposalStep3ServiceAnnual = ProposalStep3BaseStep3.merge(ProposalStep3AnnualPayment).merge(ProposalStep3PaymentOnCompletion).merge(ProposalStep3StagedPayments).merge(z.object({ serviceRateType: z.literal('Per annum') }))
export type ProposalStep3ServiceAnnualDto = z.output<typeof ProposalStep3ServiceAnnual>

export const ProposalStep3ServiceOneTime = ProposalStep3BaseStep3.merge(ProposalStep3PaymentOnCompletion).merge(ProposalStep3UpfrontPayment).merge(ProposalStep3StagedPayments).merge(z.object({ serviceRateType: z.literal('One-time fee') }))
export type ProposalStep3ServiceOneTimeDto = z.output<typeof ProposalStep3ServiceOneTime>

export const ProposalStep3ServiceSession = ProposalStep3BaseStep3.merge(ProposalStep3UpfrontPayment).merge(z.object({ serviceRateType: z.literal('Per session') }))
export type ProposalStep3ServiceSessionDto = z.output<typeof ProposalStep3ServiceSession>

export const ProposalStep3ServiceUnit = ProposalStep3BaseStep3.merge(ProposalStep3AnnualPayment).merge(z.object({ serviceRateType: z.literal('Per unit') }))
export type ProposalStep3ServiceUnitDto = z.output<typeof ProposalStep3ServiceUnit>

export const ProposalStep3AllExtraAttributes = ProposalStep3AnnualPayment.merge(ProposalStep3PaymentOnCompletion).merge(ProposalStep3StagedPayments).merge(ProposalStep3UpfrontPayment).merge(MonthlyInstallmentsOver12Months)
export type ProposalStep3AllExtraAttributesDto = z.output<typeof ProposalStep3AllExtraAttributes>

export const ProposalStep3AllAttributes = ProposalStep3BaseStep3.merge(ProposalStep3AllExtraAttributes)
export type ProposalStep3AllAttributesDto = z.output<typeof ProposalStep3AllAttributes>

export const ProposalStep3SingleDtoSchema = z.union([ProposalStep3ServiceMonthly, ProposalStep3ServiceAnnual, ProposalStep3ServiceOneTime, ProposalStep3ServiceSession, ProposalStep3ServiceUnit])
export type ProposalStep3SingleDto = z.output<typeof ProposalStep3SingleDtoSchema>

export const ProposalStep3DtoSchema = z.array(ProposalStep3SingleDtoSchema)
export type ProposalStep3Dto = z.output<typeof ProposalStep3DtoSchema>
